interface Permissions {
    addToWorkspace: boolean;
    advanceSearch: boolean;
    authorizationForecast: boolean;
    cas: boolean;
    chemical: boolean;
    citation: boolean;
    citationMap: boolean;
    claimTree: boolean;
    commentAndField: boolean;
    commentFlag: boolean;
    companySpace: boolean;
    comparePatent: boolean;
    customFieldFlag: boolean;
    customsData: boolean;
    discovery: boolean;
    email: boolean;
    export: boolean;
    family: boolean;
    familyGeo: boolean;
    familyTree: boolean;
    figure: boolean;
    fileWrapper: boolean;
    fileWrapperAdvance: boolean;
    fileWrapperAlert: boolean;
    fileWrapperModify: boolean;
    fullText: boolean;
    imageDiscovery: boolean;
    insights: boolean;
    legal: boolean;
    licensing: boolean;
    lifeScience: boolean;
    litigation: boolean;
    mlt: boolean;
    paper: boolean;
    patentValue: boolean;
    pdf: boolean;
    pdfDownload: boolean;
    pledge: boolean;
    reexamInvalid: boolean;
    semantic: boolean;
    sep: boolean;
    share: boolean;
    similarParagraph: boolean;
    simpleSearch: boolean;
    textCompare: boolean;
    vpm: boolean;
    workspaceDelete: boolean;
}

interface TplLinks {
    AU: string;
    CAA: string;
    CAB: string;
    CAD: string;
    CN: string;
    DE: string;
    EM: string;
    EPO: string;
    EPONEW: string;
    INPADOC: string;
    NO: string;
    USA: string;
    USB: string;
    UST: string;
    WO: string;
}

export interface ApiGetPatentViewInitResponse {
    canAiTranslation: boolean;
    hasJP: boolean;
    isFree: boolean;
    permissions: Permissions;
    tplLinks: TplLinks;
}

export type ApiGetPatentViewInitRequest = Record<string, string>;

export const GetPatentViewInit = Symbol.for('GetPatentViewInit');

export interface GetPatentViewInit {
    getPatentViewInit(patentId: ApiGetPatentViewInitRequest): Promise<ApiGetPatentViewInitResponse>;
}
